import { http } from '@/lib/apiClient';

export interface RoleRef { id: string; code: string; name: string }
export interface UserSummary { id: string; username: string; fullName: string; email: string; userType: 'INTERNAL' | 'VENDOR'; isActive: boolean; lastLoginAt: string | null }
export interface UserDetail extends UserSummary { phone: string | null; vendorId: string | null; mustChangePassword: boolean; createdAt: string; temporaryPassword: string | null; roles: RoleRef[] }
export interface CreateUserRequest { username: string; email: string; fullName: string; phone?: string; userType: 'INTERNAL' | 'VENDOR'; roleIds: string[] }

export const usersApi = {
  list: () => http.get<UserSummary[]>('/api/v1/users'),
  getById: (id: string) => http.get<UserDetail>(`/api/v1/users/${id}`),
  create: (body: CreateUserRequest) => http.post<UserDetail>('/api/v1/users', body),
  update: (id: string, body: { fullName: string; phone?: string; isActive: boolean }) => http.put<UserDetail>(`/api/v1/users/${id}`, body),
  activate: (id: string) => http.post<void>(`/api/v1/users/${id}/activate`),
  deactivate: (id: string) => http.post<void>(`/api/v1/users/${id}/deactivate`),
  assignRoles: (id: string, roleIds: string[]) => http.put<UserDetail>(`/api/v1/users/${id}/roles`, { roleIds }),
  resetPassword: (id: string, newPassword: string) => http.post<{ userId: string; temporaryPassword: string; mustChangePassword: boolean }>(`/api/v1/users/${id}/reset-password`, { newPassword }),
};
